import React, { useEffect, useRef } from "react";
import "@dotlottie/player-component";
import { type DotLottiePlayer } from "@dotlottie/player-component";
import animationData from "Assets/lottie/SupplyLP/MapAnimation";

interface HeroAnimationProps {
}

const HeroAnimation: React.FC<HeroAnimationProps> = () => {
   const playerRef = useRef<DotLottiePlayer>(null);

   useEffect(() => {
      const player = playerRef.current;
      if (player) {
         player.load(animationData);
      }
   }, []);

   return <>
      <dotlottie-player
         ref={playerRef}
         loop
         autoplay
         class="supplylp-hero-map supplylp-hero-map--animated"
      />
   </>
}

export default HeroAnimation;